<script>
import appConfig from "@/app.config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
   data: () => ({
       assetsPath: appConfig.assetsPath,
       showCookie: false
   }),
   mounted() {
    //    setTimeout(() => {
    //        this.showCookie = true;
    //    }, 2000);
    if (!localStorage.showCookie) {
        this.showCookie = true;
        localStorage.showCookie = 'hide';
    }
   },
   methods: {
       hide() {
           this.showCookie = false
           localStorage.showCookie = 'hide';
       }
   }
};
</script>

<template>
    <div class="p-rel">
        <transition name="slide-fade">
            <div :class="$style.cookiesBlock" class="d-inline-flex flex-row align-item-center" v-if="showCookie">
                <div>
                    <img :src="assetsPath + 'images/Panda-eating-cookies@2x.png'" :class="$style.pandaEating"/>
                </div>
                <div :class="$style.cookieBody" class="w-100">
                    <p v-html="$t('cookiePolicy.info')" />
                    <button class="btn btn-info btn-lg rounded-half " @click="hide">   {{$t('cookiePolicy.gotIt')}} </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.cookiesBlock{
    position: fixed;
    right: 25px;
    bottom: 20px;
    background-color: #fff;
    border-radius: 14px;
    width: 380px;
    padding: 30px;
    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.1);
    z-index: 2;
    .pandaEating{
        width: 79px;
        min-width: 79px;
    }
    .cookieBody{
        padding-left: 20px;
    }
    p{
        margin-bottom: 24px;
        font-size: 17px;        
    }
    button{
        width: 120px !important;
        min-width: 120px !important;
    }
}
@media only screen and (max-width: 767px){
  .cookiesBlock{
      max-width: 95%;
      left: 0;
      right: 0;
      margin: auto;
  }
}
</style>
